import { z } from "zod";
// Issue #185 — a template's default travelers (`entities/template.ts`). Stored as a map
// on the template doc, keyed by participant id, next to (and independent of) `members`.
export const TemplateParticipantSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("user"),
        userId: z.string(),
        displayName: z.string(),
        email: z.string(),
        photoUrl: z.string().optional(),
    }),
    z.object({
        kind: z.literal("managed"),
        displayName: z.string(),
        photoUrl: z.string().optional(),
    }),
]);
export const TemplateParticipantsSchema = z.record(z.string(), TemplateParticipantSchema);
// Unparseable entries are dropped rather than failing the whole template: a template
// still lists and opens when one participant record is malformed.
export const participantsToDomain = (raw) => {
    const parsed = TemplateParticipantsSchema.safeParse(raw ?? {});
    if (!parsed.success)
        return {};
    const out = {};
    for (const [id, p] of Object.entries(parsed.data))
        out[id] = p;
    return out;
};
//# sourceMappingURL=template.mapper.js.map